import { isNumeric } from "./functions";

export const gradingTypes = {
    "raw": "Manafix RAW",
    "standard": "Manafix STANDARD",
    "premium": "Manafix PREMIUM",
    "pre": "Pré-Grading",
    "no_subgrades": "Grading sem Subgrades",
    "cert_only": "Somente Certificação"
}

export const preLacreFormatLabels = {
    "with_subgrades": "Pré: lacre com subgrades (+R$49/item se prosseguir)",
    "without_subgrades": "Pré: lacre sem subgrades (+R$35/item se prosseguir)"
}

const gradingTypeAliases = {
    regular: "standard"
}

export const normalizeGradingType = (gradingType) => {
    if (!gradingType) {
        return "";
    }
    const lowerType = `${gradingType}`.toLowerCase();
    return gradingTypeAliases[lowerType] || lowerType;
}

export const getGradingTypeLabel = (gradingType) => {
    const normalized = normalizeGradingType(gradingType);
    return gradingTypes[normalized] || gradingType;
}

export const getPreLacreFormatLabel = (preLacreFormat) => {
    return preLacreFormatLabels[preLacreFormat] || preLacreFormat;
}

export const gradingTypeSupportsSubgrades = (gradingType, preLacreFormat) => {
    const normalized = normalizeGradingType(gradingType);
    if (["no_subgrades", "cert_only"].includes(normalized)) {
        return false;
    }
    if (normalized === "pre") {
        return preLacreFormat !== "without_subgrades";
    }
    return true;
}

export const gradingTypeSupportsGeneralScore = (gradingType) => {
    const normalized = normalizeGradingType(gradingType);
    return normalized !== "cert_only";
}

export const gradingTypeSupportsAutograph = (gradingType) => {
    return normalizeGradingType(gradingType) !== "premium";
}

export const priorityTypes = {
    "none": "Sem Prioridade",
    "low": "Prioridade Baixa",
    "mid": "Prioridade Média",
    "high": "Prioridade Alta",
    "max": "Prioridade Máxima"
}

export const getScoreTitle = (score) => {
    if (!isNumeric(score)) {
        if (score === "EP") {
            return "Event Promo";
        }
        if (score === "N/P") {
            return "Not Graded";
        }
    }
    const scoreNumber = parseFloat(score);
    if (scoreNumber >= 10) {
        return "Pristine";
    }
    if (scoreNumber >= 9.5) {
        return "Gem Mint"
    }
    if (scoreNumber >= 9) {
        return "Mint"
    }
    if (scoreNumber >= 8.5) {
        return "Near Mint +"
    }
    if (scoreNumber >= 8) {
        return "Near Mint"
    }
    if (scoreNumber >= 7.5) {
        return "Slightly Played +"
    }
    if (scoreNumber >= 7) {
        return "Slightly Played"
    }
    if (scoreNumber >= 6) {
        return "Slightly Played -"
    }
    if (scoreNumber >= 5) {
        return "Moderately Played +"
    }
    if (scoreNumber >= 4.5) {
        return "Moderately Played"
    }
    if (scoreNumber >= 4) {
        return "Moderately Played -"
    }
    if (scoreNumber >= 3.5) {
        return "Heavily Played +"
    }
    if (scoreNumber >= 3) {
        return "Heavily Played"
    }
    if (scoreNumber >= 2.5) {
        return "Heavily Played -"
    }
    if (scoreNumber >= 2) {
        return "Damaged"
    }
    if (scoreNumber >= 1.5) {
        return "Poor +"
    }
    if (scoreNumber >= 1) {
        return "Poor"
    }
}
